import React, { useState } from 'react';
import "./GalerieImportImg.scss";

import Img1 from "../../assets/img/galerie/galerieImg.jpg";
import Img2 from "../../assets/img/galerie/galerieImg2.jpg";
import Img3 from "../../assets/img/galerie/galerieImg3.jpg";
import Img4 from "../../assets/img/galerie/galerieImg4.jpg";
import Img5 from "../../assets/img/galerie/galerieImg5.jpg";
import Img6 from "../../assets/img/galerie/galerieImg6.jpg";
import Img7 from "../../assets/img/galerie/galerieImg7.jpg";
import Img8 from "../../assets/img/galerie/galerieImg8.jpg";
import Img9 from "../../assets/img/galerie/galerieImg9.jpg";
import Img10 from "../../assets/img/galerie/galerieImg10.jpg";
import Img11 from "../../assets/img/galerie/galerieImg11.jpg";
import Img12 from "../../assets/img/galerie/galerieImg12.jpg";
import Img13 from "../../assets/img/galerie/galerieImg13.jpg";
import Img14 from "../../assets/img/galerie/galerieImg14.jpg";
import Img15 from "../../assets/img/galerie/galerieImg15.jpg";

import Img17 from "../../assets/img/galerie/galerieImg17.jpg";
import Img18 from "../../assets/img/galerie/galerieImg18.jpg";
import Img19 from "../../assets/img/galerie/galerieImg19.jpg";
import Img21 from "../../assets/img/galerie/galerieImg21.jpg";
import Img22 from "../../assets/img/galerie/galerieImg22.jpg";
import Img23 from "../../assets/img/galerie/galerieImg23.jpg";
import Img24 from "../../assets/img/galerie/galerieImg24.jpg";
import Img25 from "../../assets/img/galerie/galerieImg25.jpg";
import Img26 from "../../assets/img/galerie/galerieImg26.jpg";
import Img27 from "../../assets/img/galerie/galerieImg27.jpg";
import Img28 from "../../assets/img/galerie/galerieImg28.jpeg";
import Img29 from "../../assets/img/galerie/galerieImg29.jpeg";
import Img30 from "../../assets/img/galerie/galerieImg30.jpeg";
import Img31 from "../../assets/img/galerie/galerieImg31.jpeg";
import Img32 from "../../assets/img/galerie/galerieImg32.jpeg";
import Img33 from "../../assets/img/galerie/galerieImg33.jpeg";

function GalerieImportImg() {

    const [selectedImg, setSelectedImg] = useState(null);

    const handleClick = (img) => {
        setSelectedImg(img);
    };

    const handleClose = () => {
        setSelectedImg(null);
    };

    return (

        <div className="photo-container">
            <div className="photo-flex">
                <img className="photo-flex__img" src={Img1} alt="Animaux" onClick={() => handleClick(Img1)} />
                <img className="photo-flex__img" src={Img2} alt="Animaux" onClick={() => handleClick(Img2)} />
                <img className="photo-flex__img" src={Img3} alt="Animaux" onClick={() => handleClick(Img3)} />
                <img className="photo-flex__img" src={Img4} alt="Animaux" onClick={() => handleClick(Img4)} />
                <img className="photo-flex__img" src={Img5} alt="Animaux" onClick={() => handleClick(Img5)} />
                <img className="photo-flex__img" src={Img6} alt="Animaux" onClick={() => handleClick(Img6)} />
                <img className="photo-flex__img" src={Img7} alt="Animaux" onClick={() => handleClick(Img7)} />
                <img className="photo-flex__img" src={Img8} alt="Animaux" onClick={() => handleClick(Img8)} />
                <img className="photo-flex__img" src={Img9} alt="Animaux" onClick={() => handleClick(Img9)} />
                <img className="photo-flex__img" src={Img10} alt="Animaux" onClick={() => handleClick(Img10)} />
                <img className="photo-flex__img" src={Img11} alt="Animaux" onClick={() => handleClick(Img11)} />
                <img className="photo-flex__img" src={Img12} alt="Animaux" onClick={() => handleClick(Img12)} />
                <img className="photo-flex__img" src={Img13} alt="Animaux" onClick={() => handleClick(Img13)} />
                <img className="photo-flex__img" src={Img14} alt="Animaux" onClick={() => handleClick(Img14)} />
                <img className="photo-flex__img" src={Img15} alt="Animaux" onClick={() => handleClick(Img15)} />
                
                <img className="photo-flex__img" src={Img17} alt="Animaux" onClick={() => handleClick(Img17)} />
                <img className="photo-flex__img" src={Img18} alt="Animaux" onClick={() => handleClick(Img18)} />
                <img className="photo-flex__img" src={Img19} alt="Animaux" onClick={() => handleClick(Img19)} />
                <img className="photo-flex__img" src={Img21} alt="Animaux" onClick={() => handleClick(Img21)} />
                <img className="photo-flex__img" src={Img22} alt="Animaux" onClick={() => handleClick(Img22)} />
                <img className="photo-flex__img" src={Img23} alt="Animaux" onClick={() => handleClick(Img23)} />
                <img className="photo-flex__img" src={Img24} alt="Animaux" onClick={() => handleClick(Img24)} />
                <img className="photo-flex__img" src={Img25} alt="Animaux" onClick={() => handleClick(Img25)} />
                <img className="photo-flex__img" src={Img26} alt="Animaux" onClick={() => handleClick(Img26)} />
                <img className="photo-flex__img" src={Img27} alt="Animaux" onClick={() => handleClick(Img27)} />
                <img className="photo-flex__img" src={Img28} alt="Animaux" onClick={() => handleClick(Img28)} />
                <img className="photo-flex__img" src={Img29} alt="Animaux" onClick={() => handleClick(Img29)} />
                <img className="photo-flex__img" src={Img30} alt="Animaux" onClick={() => handleClick(Img30)} />
                <img className="photo-flex__img" src={Img31} alt="Animaux" onClick={() => handleClick(Img31)} />
                <img className="photo-flex__img" src={Img32} alt="Animaux" onClick={() => handleClick(Img32)} />
                <img className="photo-flex__img" src={Img33} alt="Animaux" onClick={() => handleClick(Img33)} />
            </div>

            {selectedImg && (
                <div className="backdrop" onClick={handleClose}>
                    <img src={selectedImg} alt="Agrandie" className="enlarged-img" onClick={(e) => e.stopPropagation()} />
                </div>
            )}
        </div>
    );
}

export default GalerieImportImg;
